import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import EmailForm from '../components/EmailForm';
import EnrollmentForm from '../components/EnrollmentForm';
import '../styles/Kurssit.css';
import { useTranslations } from '../hooks/useTranslations';

const Kurssit = () => {
  const [showLinks, setShowLinks] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const { t } = useTranslations();

  const handleIlmottauduButtonClick = (courseId) => {
    setSelectedCourseId(courseId);
  };

  const handleEnrollmentSuccess = () => {
    setSelectedCourseId(null);
  };

  const courseFeatures = {
    intensive: [
      { key: 'coursesPage.cards.intensive.features.book', fallback: 'Kurssikirja' },
      { key: 'coursesPage.cards.intensive.features.hours', fallback: '54 opetustuntia' },
      { key: 'coursesPage.cards.intensive.features.application', fallback: 'Hakemusprosessissa avustaminen' },
      { key: 'coursesPage.cards.intensive.features.travel', fallback: 'Matkustamme kanssasi Romaniaan' },
    ],
    super: [
      { key: 'coursesPage.cards.super.features.book', fallback: 'Kurssikirja' },
      { key: 'coursesPage.cards.super.features.hours', fallback: '108 opetustuntia' },
      { key: 'coursesPage.cards.super.features.tutoring', fallback: 'Yksityisopetusta 1h' },
      { key: 'coursesPage.cards.super.features.material', fallback: 'Nettimateriaali & tehtäviä' },
      { key: 'coursesPage.cards.super.features.application', fallback: 'Hakemusprosessissa avustaminen' },
      { key: 'coursesPage.cards.super.features.travel', fallback: 'Matkustamme kanssasi Romaniaan' },
    ],
    superGuarantee: [
      { key: 'coursesPage.cards.superGuarantee.features.book', fallback: 'Kurssikirja' },
      { key: 'coursesPage.cards.superGuarantee.features.hours', fallback: '114 opetustuntia + rahanpalautus' },
      { key: 'coursesPage.cards.superGuarantee.features.tutoring', fallback: 'Yksityisopetusta 2h' },
      { key: 'coursesPage.cards.superGuarantee.features.material', fallback: 'Nettimateriaali & tehtäviä' },
      { key: 'coursesPage.cards.superGuarantee.features.application', fallback: 'Hakemusprosessissa avustaminen' },
      { key: 'coursesPage.cards.superGuarantee.features.travel', fallback: 'Matkustamme kanssasi Romaniaan' },
    ],
    applicationTravel: [
      { key: 'coursesPage.cards.applicationTravel.features.application', fallback: 'Hakemusprosessissa avustaminen' },
      { key: 'coursesPage.cards.applicationTravel.features.travel', fallback: 'Matkustamme kanssasi Romaniaan' },
    ],
    application: [
      {
        key: 'coursesPage.cards.application.features.application',
        fallback: 'Hakemusprosessissa avustaminen sekä hakemuksen toimitus yliopistoon.',
      },
    ],
    knots: [
      {
        key: 'coursesPage.cards.knots.features.description',
        fallback: 'Romaniassa 2 päivän kurssi kirurgian perusteiden teoriaan ja käytäntöön.',
      },
    ],
  };

  const renderFeatures = (courseId) =>
    courseFeatures[courseId].map(({ key, fallback }, index) => (
      <React.Fragment key={key}>
        <span className="p-with-dots"></span>
        {t(key, fallback)}
        {index < courseFeatures[courseId].length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <div className='screen'>
      <div className="kurssitsivu">
        <Navbar showLinks={showLinks} setShowLinks={setShowLinks} />
        <div className="kurssit">
          <h1>{t('coursesPage.heading', 'Kurssit')}</h1>
          <div className='kurssi-card-container'>
            <div className="kurssi-card">
              <div className="kurssi-pic-frame">
                <img src="intensiivinen-small.jpeg" alt={t('coursesPage.cards.intensive.alt', 'Intensiivinen kurssi')} className="kurssi-card-pic" loading='lazy' />
              </div>
              <div className="kurssi-header">
                <h2>{t('coursesPage.cards.intensive.title', 'Intensiivinen kurssi')}</h2>
                <p>{t('coursesPage.cards.intensive.duration', '3,5 viikkoa')}</p>
              </div>
              <div className='kurssi-text'>
                <p>
                  {renderFeatures('intensive')}
                  <br />
                  <br />
                </p>
              </div>
              <div className="ilmottaudu-button-container">
                <span className="price-label">2400€</span>
                <button onClick={() => handleIlmottauduButtonClick('intensive')} className='ilmottaudu-button'>
                  {t('coursesPage.buttons.enroll', 'Ilmottaudu')}
                </button>
              </div>
            </div>

            <div className="kurssi-card">
              <div className="kurssi-pic-frame">
                <img src="superkurssi-small.jpeg" alt={t('coursesPage.cards.super.alt', 'Superkurssi')} className="kurssi-card-pic" loading='lazy' />
              </div>
              <div className="kurssi-header1">
                <h2>{t('coursesPage.cards.super.title', 'Superkurssi')}</h2>
                <p>{t('coursesPage.cards.super.duration', '9 viikkoa')}</p>
              </div>
              <div className='kurssi-text'>
                <p>{renderFeatures('super')}</p>
              </div>
              <div className="ilmottaudu-button-container">
                <span className="price-label">4500€</span>
                <button onClick={() => handleIlmottauduButtonClick('super')} className='ilmottaudu-button'>
                  {t('coursesPage.buttons.enroll', 'Ilmottaudu')}
                </button>
              </div>
            </div>

            <div className="kurssi-card">
              <div className="kurssi-pic-frame">
                <img src="supertakuu-small.jpeg" alt={t('coursesPage.cards.superGuarantee.alt', 'Super-takuukurssi')} className="kurssi-card-pic" loading='lazy' />
              </div>
              <div className="kurssi-header">
                <h2>{t('coursesPage.cards.superGuarantee.title', 'Super-Takuu kurssi')}</h2>
                <p>{t('coursesPage.cards.superGuarantee.duration', '10 viikkoa')}</p>
              </div>
              <div className='kurssi-text'>
                <p>{renderFeatures('superGuarantee')}</p>
              </div>
              <div className="ilmottaudu-button-container">
                <span className="price-label">5500€</span>
                <button onClick={() => handleIlmottauduButtonClick('superGuarantee')} className='ilmottaudu-button'>
                  {t('coursesPage.buttons.enroll', 'Ilmottaudu')}
                </button>
              </div>
            </div>

            <div className="kurssi-card-small">
              <div className="kurssi-pic-frame">
                <img src="hakemus-matka-small.jpeg" alt={t('coursesPage.cards.applicationTravel.alt', 'Hakemuspalvelu ja matka')} className="kurssi-card-pic" loading='lazy' />
              </div>
              <div className="kurssi-header">
                <h2>{t('coursesPage.cards.applicationTravel.title', 'Hakemuspalvelu + matka')}</h2>
              </div>
              <div className='kurssi-text'>
                <p>{renderFeatures('applicationTravel')}</p>
              </div>
              <div className="ilmottaudu-button-container-small">
                <span className="price-label-small">499€</span>
                <button onClick={() => handleIlmottauduButtonClick('applicationTravel')} className='ilmottaudu-button'>
                  {t('coursesPage.buttons.enroll', 'Ilmottaudu')}
                </button>
              </div>
            </div>

            <div className="kurssi-card-small">
              <div className="kurssi-pic-frame">
                <img src="hakemus-small.jpeg" alt={t('coursesPage.cards.application.alt', 'Hakemuspalvelu')} className="kurssi-card-pic" loading='lazy' />
              </div>
              <div className="kurssi-header">
                <h2>{t('coursesPage.cards.application.title', 'Hakemuspalvelu')}</h2>
              </div>
              <div className='kurssi-text'>
                <p>{renderFeatures('application')}</p>
              </div>
              <div className="ilmottaudu-button-container-small">
                <span className="price-label-small">299€</span>
                <button onClick={() => handleIlmottauduButtonClick('application')} className='ilmottaudu-button'>
                  {t('coursesPage.buttons.enroll', 'Ilmottaudu')}
                </button>
              </div>
            </div>

            <div className="kurssi-card-small">
              <div className="kurssi-pic-frame">
                <img src="kirurgi.jpg" alt={t('coursesPage.cards.knots.alt', 'Kirurginen kurssi')} className="kurssi-card-pic" loading='lazy' />
              </div>
              <div className="kurssi-header">
                <h2>{t('coursesPage.cards.knots.title', 'Knots & Suture')}</h2>
              </div>
              <div className='kurssi-text'>
                <p>{renderFeatures('knots')}</p>
              </div>
              <div className="ilmottaudu-button-container-small">
                <span className="price-label-small">149€</span>
                <button onClick={() => handleIlmottauduButtonClick('knots')} className='ilmottaudu-button'>
                  {t('coursesPage.buttons.enroll', 'Ilmottaudu')}
                </button>
              </div>
            </div>
          </div>
        </div>
        <EmailForm />
        {selectedCourseId && (
          <EnrollmentForm courseId={selectedCourseId} onEnrollmentSuccess={handleEnrollmentSuccess} />
        )}
      </div>
    </div>
  );
};

export default Kurssit;
